<template>
    <v-stepper vertical class="elevation-0">
        <v-stepper-step step="1" v-bind:complete="order.created_at != null">
            {{ new Date(order.created_at) | date(dateFormat) }}
            <small>Order placed</small>
        </v-stepper-step>
        <v-stepper-content step="1" />
        <v-stepper-step step="2" v-bind:complete="order.assigned_at != null">
            {{
                order.assigned_at &&
                    new Date(order.assigned_at) | date(dateFormat)
            }}
            <small>Courier assigned</small>
        </v-stepper-step>
        <v-stepper-content step="2" />
        <v-stepper-step step="3" v-bind:complete="order.started_at != null">
            {{
                order.started_at &&
                    new Date(order.started_at) | date(dateFormat)
            }}
            <small>Started</small>
        </v-stepper-step>
        <v-stepper-content step="3" />
        <v-stepper-step step="4" v-bind:complete="order.completed_at != null">
            {{
                order.completed_at &&
                    new Date(order.completed_at) | date(dateFormat)
            }}
            <small>Completed</small>
        </v-stepper-step>
        <v-stepper-step
            step="x"
            v-bind:complete="order.cancelled_at != null"
            complete-icon="mdi-cancel"
            color="error"
        >
            {{
                order.cancelled_at &&
                    new Date(order.cancelled_at) | date(dateFormat)
            }}
            <small>Cancelled</small>
        </v-stepper-step>
    </v-stepper>
</template>

<script>
export default {
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dateFormat: 'p, dd-MMM-yyyy'
        };
    }
};
</script>
